// extracted by mini-css-extract-plugin
export default {"container":"Features_container__4i3pU","row":"Features_row__uFMN+","cell":"Features_cell__hR46z","active":"Features_active__gAl2Y","inactive":"Features_inactive__aoyWK"};